import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { showError } from '../../../../utils/Notifications';
// import { MediaSaveRequestDto } from '../dto/request/media-save-request';
import mediaService from '../services/media.service';

const initialState = {
  status: 'idle',
  error: null as string | null,
};

export const saveMedia = createAsyncThunk(
  '/media/saveMedia',
  async (saveRequest: FormData, { rejectWithValue }) => {
    try {
      return await mediaService.saveMedia(saveRequest);
    } catch (e) {
      return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
    }
  }
);

// export const deleteMedia = createAsyncThunk(
//   '/media/deleteMedia',
//   async (fileName: string, { rejectWithValue }) => {
//     try {
//       await mediaService.deleteMedia(fileName);
//     } catch (e) {
//       return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
//     }
//   }
// );

const mediaSlice = createSlice({
  name: 'mediaSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveMedia.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveMedia.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(saveMedia.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
        showError(`Saving image failed. ${action.payload as string}`);
      });
    // .addCase(deleteMedia.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(deleteMedia.fulfilled, (state) => {
    //   state.status = 'succeeded';
    // })
    // .addCase(deleteMedia.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.payload as string;
    //   showError(`Deleting media failed. ${action.payload as string}`);
    // });
  },
});

export default mediaSlice.reducer;
